<h1 *ngIf="title" style="text-align: center;">{{ title }}</h1>
<mat-stepper linear="true" #stepper>
  <mat-step label="Modele">
    <ng-template matStepContent>
      <ng-container *ngIf="roofType === roofTypes.ONE_SLOPE">
        <h2>Calculator pentru acoperiș într-o apă - varianta care îți simplifică alegerile</h2>
        <p>Dacă ești în căutarea unei soluții eficiente pentru a-ți calcula necesarul de materiale pentru un acoperiș într-o apă, ai ajuns
          în locul potrivit. <span [ngClass]="showMore ? '' : 'hide-mobile'">Pe platforma noastră, beneficiezi de un calculator de acoperiș într-o apă care îți oferă calcule automate
            exacte, adaptate fiecărui model și brand de învelitori.</span>
          <button color="primary" *ngIf="!showMore" mat-button (click)="showMore = true">vezi mai mult</button>
        </p>
        <div [ngClass]="showMore ? '' : 'hide-content'">
          <p>Indiferent dacă preferi <a href="https://experttabla.ro/bilka/">Bilka</a> sau <a href="https://experttabla.ro/wetterbest/">Wetterbest</a>
            pentru sistemul de învelitori, îți punem la dispoziție un instrument ușor de
            utilizat, conceput pentru a-ți simplifica întregul proces de planificare.</p>
          <h3>Calculator acoperiș într-o apă - de ce să îl folosești?</h3>
          <p>Calitatea premium la preț bun, profesionalismul și transparența sunt valorile care ne ghidează în fiecare zi. Echipa noastră de
            experți este mereu gata să te ajute cu sfaturi și recomandări personalizate. Cu ajutorul calculatorului nostru, obții un necesar
            transparent, fără costuri ascunse. Mai mult, în funcție de modelul ales, primești o estimare exactă a materialelor necesare.</p>
          <p>Folosind <a href="https://experttabla.ro/calculator/ro/#">calculatorul pentru acoperiș</a> pus la dispoziție de echipa noastră
            vei avea acces la toate informațiile necesare pentru
            a-ți planifica proiectul de acoperiș într-o apă cu ușurință. Printre avantajele cheie se numără interfața intuitivă care îți
            permite să introduci rapid dimensiunile acoperișului și să obții imediat rezultatele. În plus, economisești timp și bani evitând
            suprapunerile și estimările greșite ale necesarului de materiale. De asemenea, poți selecta dintr-o varietate de modele și
            branduri, cum ar fi <a href="https://experttabla.ro/bilka/">Bilka</a> și <a
              href="https://experttabla.ro/wetterbest/">Wetterbest</a>, pentru a găsi soluția perfectă pentru nevoile tale.</p>
          <p>Nu mai pierde timpul cu estimări care pot fi eronate! Utilizează calculatorul nostru de acoperiș într-o apă și bucură-te de un
            proces transparent, precis și profesional. Apelează chiar acum la calculatorul de acoperiș într-o apă de la Experttabla.ro și
            începe să-ți planifici acoperișul perfect pentru casa ta!
            <button color="primary" mat-button (click)="showMore = false">vezi mai puțin</button>
          </p>

        </div>
      </ng-container>
      <ng-container *ngIf="roofType === roofTypes.TWO_SLOPES">
        <h2>Calculator pentru acoperiș în 2 ape - folosește-l în cel mai simplu mod!</h2>
        <p>Indiferent că ești un montator profesionist și montezi acoperișuri sau proprietar al unei case care își dorește un acoperiș nou,
          calculatorul nostru de acoperișuri în 2 ape <a href="https://experttabla.ro/bilka/">Bilka</a> sau <a
            href="https://experttabla.ro/wetterbest/">Wetterbest</a> îți oferă toate detaliile de care ai nevoie. <span [ngClass]="showMore ? '' : 'hide-mobile'">Tot ce ai de făcut
          este să introduci dimensiunile acoperișului conform proiectului casei tale și modelul de tablă Bilka sau de tablă Wetterbest pe
            care îl preferi și primești instant de la calculatorul tablei acoperișului în 2 ape un rezultat complet cu cantități și prețuri.</span>
          <button color="primary" *ngIf="!showMore" mat-button (click)="showMore = true">vezi mai mult</button>
        </p>
        <div [ngClass]="showMore ? '' : 'hide-content'">
          <h3>Calculator suprafață acoperiș în 2 ape - totul la un click distanță</h3>
          <p>Acest calculator al suprafeței acoperișurilor în 2 ape ușor de utilizat îți arată exact ce ai nevoie - de la cantitatea corectă
            de tablă, până la toate accesoriile necesare pentru proiectul tău. Pe lângă cantitati, calculatorul îți calculează și schița
            acoperișului în două ape, astfel poți confirma că tablă va fi tăiată la dimensiunea bună, eliminând posibile erori ale
            viitorului tău acoperiș în 2
            ape. Nu vei mai face liste interminabile de materiale deoarece de la calculul acoperișului în 2 ape la comanda finală, totul e
            la un click distanță.</p>
          <p>Cu Experttabla.ro ai certitudinea unor calcule automate exacte bazate pe modelul și dimensiunile acoperișului tău. Ai acum la
            dispoziție în mod gratuit un calculator de acoperiș în două ape complet, transparent, fără surprize. La noi găsești calcule
            automate exacte, tablă <a href="https://experttabla.ro/bilka/">Bilka</a> sau <a href="https://experttabla.ro/wetterbest/">Wetterbest</a>
            de calitate înaltă la prețuri competitive, consiliere profesionistă și multă
            transparență. Încredințează proiectul viitorului tău acoperiș experților noștri și construiește cu încredere deplină în
            materiale și calcule precise.

            <button color="primary" mat-button (click)="showMore = false">vezi mai puțin</button>
          </p>

        </div>
      </ng-container>
      <ng-container *ngIf="roofType === roofTypes.FOUR_SLOPES">
        <h2>Calculator acoperiș în 4 ape - precizie maximă pentru eficiență și costuri corecte</h2>
        <p>Indiferent că ai nevoie de un calcul de materiale necesare pentru un acoperiș în 4 ape pentru casa ta, pensiunea sau sediul
          firmei tale, noi îți oferim o soluție ușoară și exactă.<span [ngClass]="showMore ? '' : 'hide-mobile'"> Instrumentul nostru online de tip calculator pentru acoperișuri în 4 ape
          Bilka sau Wetterbest te ajută să determini cu precizie necesarul de materiale pentru învelitoarea metalică, economisind timp și
            bani.</span>
          <button color="primary" *ngIf="!showMore" mat-button (click)="showMore = true">vezi mai mult</button>
        </p>
        <div [ngClass]="showMore ? '' : 'hide-content'">
          <p>Ia decizia corectă pentru învelitoarea casei tale folosind un calculator pentru tabla acoperișului în 4 ape! Consultanții
            noștri îți vor oferi recomandări pentru a alege soluția potrivită în funcție de bugetul și nevoile tale.</p>
          <h3>Calculator suprafață acoperiș în 4 ape - cum funcționează?</h3>
          <p>Introdu dimensiunile acoperișului si tipul de tablă iar calculatorul nostru pentru acoperișuri în patru ape va calcula automat
            cantitatea necesară de tablă <a href="https://experttabla.ro/bilka/">Bilka</a> sau <a href="https://experttabla.ro/wetterbest/">Wetterbest</a>,
            schița a acoperișului, accesoriile, precum și alte materiale. Beneficiezi de calcule automate exacte pentru diferite tipuri de
            acoperișuri în 4 ape, prețuri transparente la materiale și accesorii de înaltă calitate, inclusiv de o listă detaliată cu
            necesarul pentru proiectul tău.</p>
          <p>La Experttabla.ro, ne mândrim cu valorile pe care noi le considerăm de bază: calcule automate exacte, consiliere profesională
            și prețuri corecte pentru materiale de calitate superioară. Suntem pregătiți mereu să-ți oferim produse de calitate la un preț
            bun, pentru ca acoperișul tău să reziste ani îndelungați. Contactează-ne acum!
            <button color="primary" mat-button (click)="showMore = false">vezi mai puțin</button>
          </p>
        </div>
      </ng-container>
      <h2 *ngIf="subtitle">{{ subtitle }}</h2>
      <roof-models [productType]="roofType === roofTypes.FENCE_SLAT ? productTypes.FenceSlats : productTypes.Tile"></roof-models>
    </ng-template>
  </mat-step>

  <mat-step label="Măsurători">
    <ng-template matStepContent>
      <calculation-custom *ngIf="roofType === roofTypes.MANUAL"></calculation-custom>
      <measurements-common
        *ngIf="roofType === roofTypes.SHAPES || roofType === roofTypes.ONE_SLOPE || roofType === roofTypes.TWO_SLOPES || roofType === roofTypes.FOUR_SLOPES|| roofType === roofTypes.FENCE_SLAT"></measurements-common>
    </ng-template>
  </mat-step>

  <ng-container *ngIf="roofType !== roofTypes.MANUAL && roofType !== roofTypes.SHAPES && roofType !== roofTypes.FENCE_SLAT">
    <mat-step label="Schițe">
      <ng-template matStepContent>
        <roof-sketches></roof-sketches>
      </ng-template>
    </mat-step>
  </ng-container>

  <mat-step label="Accesorii">
    <ng-template matStepContent>
      <roof-accessories></roof-accessories>
    </ng-template>
  </mat-step>
</mat-stepper>
